import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import { HttpService, API } from '../../config/react'
const DropBoxImageSync = () => {
  const location = useLocation()
  const [expirationTime, setExpirationTime] = useState(null)
  const authUrl = `https://www.dropbox.com/oauth2/authorize?client_id=rvaq0ic0369pr9r&response_type=code&redirect_uri=http://localhost:3000&token_access_type=offline`
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const code = queryParams.get('code')
    if (code) {
      getTokens(code)
    } else {
      window.location.href = authUrl
    }
  }, [])
  async function getTokens(AUTHORIZATION_CODE) {
    const param = {
      code: AUTHORIZATION_CODE
    }
    HttpService.postApi(API.GenerateAccessToken, param).then((response) => {
      if (response.data.result) {
        calculateExpirationTime(response.data.result.expires_in)
      }
      return true
    })
  }
  const calculateExpirationTime = (expiresIn) => {
    const currentTime = Date.now()
    const expirationTimestamp = currentTime + expiresIn * 1000
    localStorage.setItem('tokenExpiration', expirationTimestamp)
    setExpirationTime(new Date(expirationTimestamp).toLocaleString())
    console.log(expirationTime)
  }
  return (
    <>
      <h1>DropBoxImageSync{location.search}</h1>
    </>
  )
}
export default DropBoxImageSync
